import api from '@/api';

export default {
  namespaced: true,
  state: {
    topics: [],
    currentTopic: null,
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0
    },
    filters: {
      search: '',
      status: '',
      chapter_subject_id: null
    }
  },
  mutations: {
    SET_TOPICS(state, topics) {
      state.topics = topics;
    },
    SET_CURRENT_TOPIC(state, topic) {
      state.currentTopic = topic;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    ADD_TOPIC(state, topic) {
      state.topics.unshift({
          ...topic,
          chapter_subject: topic.chapter_subject || null
      });
  },
  
  UPDATE_TOPIC(state, updatedTopic) {
      const index = state.topics.findIndex(t => t.id === updatedTopic.id);
      if (index !== -1) {
          state.topics.splice(index, 1, {
              ...updatedTopic,
              chapter_subject: updatedTopic.chapter_subject || state.topics[index].chapter_subject
          });
        }
      },
    DELETE_TOPIC(state, topicId) {
      state.topics = state.topics.filter(t => t.id !== topicId);
    }
  },
  actions: {
    async fetchTopics({ commit, state }, { page = 1, per_page = 10 } = {}) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/topics', {
          params: {
            page: page || state.pagination.currentPage,
            per_page: per_page || state.pagination.perPage,
            search: state.filters.search,
            status: state.filters.status,
            chapter_subject_id: state.filters.chapter_subject_id,
            with: 'chapterSubject'
          }
        });
        
        commit('SET_TOPICS', response.data.data);
        commit('SET_PAGINATION', {
          currentPage: response.data.meta.current_page,
          totalPages: response.data.meta.last_page,
          totalItems: response.data.meta.total,
          perPage: response.data.meta.per_page,
          from: response.data.meta.from,
          to: response.data.meta.to
        });
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchTopic({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/topics/${id}`, {
          params: { with: 'chapterSubject.chapter,chapterSubject.subject' }
        });
        commit('SET_CURRENT_TOPIC', response.data.data);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createTopic({ commit }, formData) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post('/topics', formData);
        commit('ADD_TOPIC', response.data.data);
        return response.data;
      } catch (error) {
        if (error.response?.status === 422) {
          throw error.response.data.errors;
        }
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateTopic({ commit }, { id, topicData }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.put(`/topics/${id}`, topicData);
        commit('UPDATE_TOPIC', response.data.data);
        return response.data;
      } catch (error) {
        if (error.response?.status === 422) {
          throw error;
        }
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteTopic({ commit }, topicId) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`/topics/${topicId}`);
        commit('DELETE_TOPIC', topicId);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    setFilters({ commit, dispatch }, filters) {
      commit('SET_FILTERS', filters);
      dispatch('fetchTopics');
    }
  },
  getters: {
    topics: state => state.topics,
    topic: state => state.currentTopic,
    isLoading: state => state.isLoading,
    error: state => state.error,
    pagination: state => state.pagination
  }
};